import React from 'react';
import List from '../../List';
import { legals } from '../../../../../constants';

function getLegals(service, i18n) {
  const values = legals.reduce((acc, legal) => {
    if (service.lawSection[legal.value]) {
      acc.push(legal.title);
    }
    return acc;
  }, []);

  return values.length > 0
    ? values.join(', ')
    : i18n('intermediary.misc.no_legal_basis');
}

const MessagesPreviewList = ({ i18n, service }) => (
  <List>
    <List.Item
      title={i18n('intermediary.messaging.serviceNameFin')}
      value={service.serviceNameFin}
    />
    <List.Item
      title={i18n('intermediary.messaging.serviceNameSve')}
      value={service.serviceNameSve}
    />
    <List.Item
      title={i18n('intermediary.messaging.serviceNameEng')}
      value={service.serviceNameEng}
    />
    <List.Item
      title={i18n('intermediary.messaging.functionalDescription')}
      value={service.serviceFunctionalDesc}
    />

    <List.Item
      title={i18n('forms.general.lawSection.titleMessages')}
      value={getLegals(service, i18n)}
    />
  </List>
);

export default MessagesPreviewList;
